import { Tag, Tooltip } from 'antd'
import { Info } from 'lucide-react'
import type { CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  /** Optional tooltip override; defaults to organization.notApiBacked.tooltip. */
  tooltip?: string
  /** Render as a chevron icon only (no tag wrapper). */
  iconOnly?: boolean
  style?: CSSProperties
}

/**
 * Marker used on UI elements (fields, KPIs, columns) whose data is not yet
 * persisted by the API. Keeps the visual present so designers can see the
 * intended layout while flagging it as not-yet-real.
 */
export const ApiPendingBadge = ({ tooltip, iconOnly, style }: Props) => {
  const { t } = useTranslation()
  const title = tooltip ?? t('organization.notApiBacked.tooltip')

  if (iconOnly) {
    return (
      <Tooltip title={title}>
        <Info
          size={12}
          aria-label={title}
          style={{
            color: 'var(--ant-color-warning)',
            verticalAlign: 'middle',
            ...style
          }}
        />
      </Tooltip>
    )
  }

  return (
    <Tooltip title={title}>
      <Tag
        color="warning"
        icon={
          <Info size={10} style={{ flex: '0 0 auto', marginInlineEnd: 2 }} />
        }
        style={{
          alignItems: 'center',
          display: 'inline-flex',
          fontSize: 10,
          lineHeight: 1,
          marginInlineEnd: 0,
          padding: '0 5px',
          ...style
        }}
      >
        {t('organization.notApiBacked.short')}
      </Tag>
    </Tooltip>
  )
}
